// @ts-strict-ignore
import {getProjectId, getWorkspaceId} from 'common/report/util';

import {appApiUrl} from '../utils';
import {BaseClient} from '../utils/base-client';

class LookupTablesClient extends BaseClient {
  buildEndpoint({projectId, workspaceId}) {
    projectId = projectId || getProjectId();
    workspaceId = workspaceId || getWorkspaceId();
    return appApiUrl(`data-definitions/lookup-tables`, {projectId, workspaceId});
  }

  public buildRequestBody({dataGroupIds}) {
    // dataGroupIds are included in body of DELETE requests
    return dataGroupIds ? JSON.stringify({'data-group-ids': dataGroupIds}) : null;
  }

  public processResponse(response) {
    if (response.status === `error`) {
      throw response.error;
    }
    return response.results;
  }
}

export const lookupTablesClient = new LookupTablesClient();
